import type { ScheduleFormData } from '@/modules/schedule/types/schedule-form-data.type'
import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export const saveScheduleService = async (payload: ScheduleFormData) => {
  const { data } = await api.post<ResponseAPI>('agendamento', payload)

  return data
}
